import CrossdockingRequests from '../../server/crossdocking';
import { addLoading, removeLoading } from './loading';

export const listCrossdockingCustomerOrders = (branchCode, productCode, inboundOrderId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CrossdockingRequests.listCrossdockingCustomerOrders(branchCode, productCode, inboundOrderId);
  } finally {
    dispatch(removeLoading());
  }
};

export const getAllCrossdockings = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CrossdockingRequests.getAllCrossdockings();
  } finally {
    dispatch(removeLoading());
  }
};

export const cancelCrossdocking = (crossdockingIds) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CrossdockingRequests.cancelCrossdocking(crossdockingIds);
  } finally {
    dispatch(removeLoading());
  }
};
